import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { OrderStatusList } from '../../api/models';

export type TABLE_TYPE = Table<OrderStatusList>;

export const TABLE = 'orderStatusList';
const SCHEMA = 'orderStatusId, sortId';

class OrderStatusListDatabase implements DataRepository<OrderStatusList> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<OrderStatusList | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: OrderStatusList, key: Key): Promise<OrderStatusList> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: OrderStatusList[]): Promise<OrderStatusList[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<OrderStatusList[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const OrderStatusListDB = new OrderStatusListDatabase(db);
